import common from "@/services/common";
import NflAllTeams from "@/services/NflAllTeam.js";
import axios from "axios";
import _ from "lodash";
import {SocketInstance} from "@/main";

const state = () => ({
    Teams: [],
    injuries: [],
    depthChart: [],
    upcomingGames: [],
    operator: "",
    position: "",
    cloneTeam: [],
    playersDetail: [],
    loadingStatus: false,
    getTeamStatus: false,
    teamBuildStatus: false,
    topPlaysStatus: false,
    nflplayerDetailLoader: false,
    AllSlate: [],
    buildTeam: [],
    TeamStack: [],
    savedLineup: [],
    LineupBuild: [],
    teamInfo: [],
    playerReset: [],
    exposure: [],
    playerPerTeam: "",
    topPlayers: [],
    setTopPlaysData: [],
    premiumFilterList: [],
    TopStudAndValues: [],
    playerTrends: [],
    fullStats: [],
    scoring: [],
    playerSwap: [],
    status: true,
    nfl_props: [],
    nfl_adp: [],
    nflNews: [],
    nflTeamDepthChart: [],
    rankings: [],
    ranking_loading: false,
});

const mutations = {
    SET_EXPOSURE(state, data) {
        if (localStorage.getItem('gameOperator') === "FanDuel" && localStorage.getItem('gameType') === "Single") {
            state.exposure.push(data);
            //console.log('exposure nfl Fd', state.exposure);
        } else {
            state.exposure = data;
            //console.log('exposure nfl', state.exposure);
        }
    },

    REMOVE_EXPOSURE(state) {
        state.exposure = [];
        //console.log('exposure remove nhl', state.exposure);
    },

    SET_TOP_PLAYS(state, data) {
        state.setTopPlaysData = data;
        //console.log('top plays: ', state.setTopPlaysData);
    },

    SHOW_TOP_PLAYS(state, data) {
        state.topPlayers = data;
    },

    SHOW_PREMIUM_FILTER(state, data) {
        state.premiumFilterList = data;
    },

    SET_TEAMS(state, teams) {
        state.Teams = teams;
        // state.newArryTeam.push(...state.Teams);
        //console.log('teams nfl', state.Teams);
    },

    SET_INJURIES(state, data) {
        state.injuries = data;
    },

    SET_DEPTHCHART(state, data) {
        state.depthChart = data;
    },

    SET_UPCOMINGGAMES(state, data) {
        state.upcomingGames = data;
    },

    SET_CLONE(state, clone) {
        state.cloneTeam = {...clone};
        // state.newArrayClone.push(...state.cloneTeam);
        //console.log('clone teams nfl', state.cloneTeam);
    },

    SET_LOADING(state, newLoadingStatus) {
        state.loadingStatus = newLoadingStatus;
    },

    SET_PLAYERDETAIL_LOADER(state, loader) {
        state.nflplayerDetailLoader = loader;
    },

    SET_TEAM_LOADER(state, loader) {
        state.getTeamStatus = loader;
    },

    SET_BUILD_TEAM_LOADER(state, status) {
        state.teamBuildStatus = status;
    },

    SET_TOP_PLAYS_LOADER(state, status) {
        state.topPlaysStatus = status;
    },

    SET_SLATE(state, slate) {
        state.AllSlate = slate.filter((value) => {
            return value.Operator !== "Yahoo";
        });
    },

    SET_USER_PLAN(state, data) {
        this.state.userModule.userState = data;
    },

    SLATE_STATUS(state, status) {
        state.status = status;
    },

    SET_PLAYER(state, playerDetail) {
        // state.playersDetail = [];
        state.playersDetail = playerDetail;
        //console.log('player nhl', typeof state.playersDetail, state.playersDetail);
    },

    SET_BUILD_TEAM(state, buildTeam) {
        state.buildTeam = buildTeam;
        // //console.log("build team", state.buildTeam);
    },

    SET_PLAYER_SWAP(state, swapData) {
        state.playerSwap = swapData;
    },

    SET_TEAM_STACK(state, teamStack) {
        state.TeamStack = teamStack;
    },

    SET_SAVE_LINEUP(state, lineup) {
        state.savedLineup = lineup;
        // //console.log("@", state.savedLineup);
    },

    SET_LINE_Up_BUILD(state, lineupBuild) {
        state.LineupBuild = lineupBuild;
    },

    SET_TEAM_DETAIL(state, info) {
        state.teamInfo = info;
        // //console.log("teamInfo", typeof state.teamInfo, state.teamInfo);
    },

    SET_RESET_PLAYERS(state, resetData) {
        state.playerReset = resetData;
        // //console.log(state.playerReset);
    },

    SET_PLAYER_PER_TEAM(state, playerPerTeamData) {
        state.playerPerTeam = playerPerTeamData.teamStack.some((element) => {
            return element.minNoOfPlayer > 0;
        });
        //console.log('playerPerTeam', state.playerPerTeam);
    },

    SET_TOP_PLAYERS(state, data) {
        state.TopStudAndValues = data;
        //console.log('top players', state.TopStudAndValues);
    },

    SET_PLAYER_TRENDs(state, data) {
        state.playerTrends = data;
    },

    SET_FULL_STAT(state, data) {
        state.fullStats = data;
    },

    SET_SCORING(state, data) {
        state.scoring = data;
    },

    SET_NFL_PROPS(state, data) {
        state.nfl_props = data;
    },

    SET_ADP(state, data) {
        state.nfl_adp = data;
    },

    SET_NFL_NEWS(state, data) {
        state.nflNews = data;
    },

    SET_TEAM_DEPTH(state, data) {
        state.nflTeamDepthChart = data;
    },

    SET_RANKINGS(state, data) {
        state.nfl_adp = data;
    },

    SET_RANKING_LOADING(state, data) {
        state.ranking_loading = data;
    },
};

const actions = {
    async getSlate({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        await NflAllTeams.getAllSlate(payload || localStorage.getItem("user"))
            .then((res) => {
                commit("SET_SLATE", res.data.data);
                commit("SLATE_STATUS", res.data.success);
                if (res.data.success) {
                    const notification_1 = {
                        type: "success", message: "Success",
                    };
                    dispatch("notification/add", notification_1, {root: true});
                    commit("SET_USER_PLAN", res.data.userData);
                }
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error", message: "There was an error with Get All Slates: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async getPlayer({commit}, payload) {
        // cleaning up SET_PLAYER
        commit("SET_PLAYER", []);
        // removing previous slate listener..
        SocketInstance.removeAllListeners(`nflgetPlayers-success-${localStorage.getItem("previousSlate")}`);

        try {
            commit("SET_LOADING", true);
            SocketInstance.emit("nflgetPlayers", payload);
            setTimeout(() => {
                commit("SET_LOADING", false);
            }, 12000);

            //? socket listening for response...
            SocketInstance.on(`nflgetPlayers-success-${payload.SlateID}`, function (res) {
                if (res.success) {
                    commit("SET_PLAYER", res.doc);
                    console.log("response", res.doc);
                }
            });

            // const res = await NflAllTeams.getPlayersDetails(payload);
        } catch (err) {
            console.error("There was an error with Get NFL Players" + err.message);
        }
    },

    async getTeamDetails({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        await NflAllTeams.teamDetails(payload)
            .then((res) => {
                //  ;
                commit("SET_TEAM_DETAIL", res.data);
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error", message: "There was an error with Get Team Details: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async getBuildTeam({commit, dispatch}, params) {
        commit("SET_BUILD_TEAM_LOADER", true);
        await NflAllTeams.getTeamBuild(params)
            .then((res) => {
                commit("SET_BUILD_TEAM", res.data);
                commit("SET_BUILD_TEAM_LOADER", false);
                if (res.data.status == 1 || res.data.allTeams.length == 0) {
                    const notification = {
                        type: "error", message: "No Lineup has been created!!",
                    };
                    return dispatch("notification/add", notification, {root: true});
                } else {
                    const notification_1 = {
                        type: "success", message: "Team has been Created.",
                    };
                    return dispatch("notification/add", notification_1, {root: true});
                }
            })
            .catch((err) => {
                console.error(err);
                const notification = {
                    type: "error", message: "There was an error with Get Build Teams",
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async FetchSwapPlayer({commit}, payload) {
        try {
            const res = await NflAllTeams.getPlayerSwap(payload);
            commit("SET_PLAYER_SWAP", res.data);
        } catch (err) {
            console.error("There was an error with Get Players swap" + err.message);
        }
    },

    async resetPlayers({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        await NflAllTeams.resetPlayers(payload)
            .then((res) => {
                commit("SET_RESET_PLAYERS", res.data);
                commit("REMOVE_EXPOSURE");
                commit("SET_LOADING", false);
                const notification = {
                    type: "success", message: "Player has been reset.",
                };
                dispatch("notification/add", notification, {root: true});
            })
            .catch((err) => {
                const notification = {
                    type: "error", message: "There was an error with Unlock Player: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    getSaveLineup({commit, dispatch}, buildTeam) {
        commit("SET_BUILD_TEAM_LOADER", true);
        NflAllTeams.savedLineup(buildTeam)
            .then((res) => {
                commit("SET_SAVE_LINEUP", res.data.doc);
                commit("SET_BUILD_TEAM_LOADER", false);
                if (!res.data.success) {
                    const notification = {
                        type: "error", message: "Error please try again!!",
                    };
                    return dispatch("notification/add", notification, {root: true});
                } else {
                    const notification_1 = {
                        type: "success", message: "Build saved successfully.",
                    };
                    return dispatch("notification/add", notification_1, {root: true});
                }
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error", message: "There was an error with Get save Lineup.: " + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    getTeamStack({commit, dispatch}, slateId) {
        commit("SET_TEAM_LOADER", true);
        NflAllTeams.getTeamStack(slateId)
            .then((res) => {
                commit("SET_TEAM_STACK", res.data);
                commit("SET_TEAM_LOADER", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error", message: "There was an error with Get Team Stack: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    getPlayerPerTeam({commit}, TeamDetails) {
        commit("SET_LOADING", true);
        NflAllTeams.playerPerTeam(TeamDetails)
            .then((response) => {
                commit("SET_PLAYER_PER_TEAM", response.data.result);
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error", message: "There was an error with Get Player per team." + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async SetExposure({commit, dispatch}, values) {
        await axios
            .post("https://api.fantasylineups.com/user/setExposure", values)
            .then((res) => {
                if (res.data.success == false) {
                    commit("SET_EXPOSURE", res.data);
                    const notification = {
                        type: "info", message: res.data.message,
                    };
                    dispatch("notification/add", notification, {root: true});
                } else {
                    commit("SET_EXPOSURE", res.data);
                }
            })
            .catch((err) => {
                const notification = {
                    type: "error", message: "There was an error with SetExposure: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async unlockPlayers({commit, dispatch}, payload) {
        await NflAllTeams.unlockPlayer(payload)
            .then((res) => {
            })
            .catch((err) => {
                const notification = {
                    type: "error", message: "There was an error with Unlock Player: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async getTeams({commit}) {
        commit("SET_TEAM_LOADER", true);
        try {
            const res = await NflAllTeams.getAllTeams();
            commit("SET_TEAMS", res.data); //* this will responsible to change the actual state not the action method...
            commit("SET_CLONE", res.data);
            commit("SET_TEAM_LOADER", false);
        } catch (err) {
            return console.error("There was an error with getTeams:" + err.message);
        }
    },

    async getInjuries({commit}, payload) {
        try {
            const res = await NflAllTeams.getInjuries(payload);
            commit("SET_INJURIES", res.data); //* this will responsible to change the actual state not the action method...
        } catch (err) {
            return console.error("There was an error with getting Injuries:" + err.message);
        }
    },

    async getDepth({commit}, payload) {
        try {
            const res = await NflAllTeams.getDepthChart(payload);
            commit("SET_DEPTHCHART", res.data); //* this will responsible to change the actual state not the action method...
        } catch (err) {
            return console.error("There was an error with getting Injuries:" + err.message);
        }
    },

    async getUpcomingGames({commit}, payload) {
        try {
            const res = await NflAllTeams.getUpcomingGames(payload);
            commit("SET_UPCOMINGGAMES", res.data); //* this will responsible to change the actual state not the action method...
        } catch (err) {
            return console.error("There was an error with getting Injuries:" + err.message);
        }
    },

    async SetTopPlays({commit, dispatch}, payload) {
        try {
            const res = await NflAllTeams.setTopPlays(payload);
            commit("SET_TOP_PLAYS", res.data);
        } catch (err) {
            const notification = {
                type: "error", message: "There was an error with setting up top players" + err.message,
            };
            dispatch("notification/add", notification, {root: true});
        }
    },

    async GetTopPlays({commit, dispatch}, payload) {
        commit("SET_TOP_PLAYS_LOADER", true);
        try {
            const res = await NflAllTeams.getTopPlays(payload);
            commit("SHOW_TOP_PLAYS", res.data);
            commit("SET_TOP_PLAYS_LOADER", false);
            const notification = {
                type: "success", message: "Player updated successfully.",
            };
            dispatch("notification/add", notification, {root: true});
        } catch (err) {
            const notification_1 = {
                type: "error", message: "There was an error with showing up top players" + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    GetPremiumFilterList({commit, dispatch}, payload) {
        // commit('SET_TOP_PLAYS_LOADER', true);
        NflAllTeams.getPremiumFilters(payload)
            .then((res) => {
                commit("SHOW_PREMIUM_FILTER", res.data);
                // commit('SET_TOP_PLAYS_LOADER', false);
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error", message: "There was an error with showing up premium filters" + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    async GetTopPlayers({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        try {
            const res = await NflAllTeams.getTopPlayers(payload);
            commit("SET_TOP_PLAYERS", res.data);
            commit("SET_LOADING", false);
        } catch (err) {
            const notification_1 = {
                type: "error", message: "There was an error with fetching: " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    FetchPlayerTrends({commit, dispatch}, payload) {
        commit("SET_TEAM_LOADER", true);
        NflAllTeams.getPlayerTrend(payload)
            .then((res) => {
                commit("SET_PLAYER_TRENDs", res.data.data);
                commit("SET_TEAM_LOADER", false);
                const notification = {
                    type: "success", message: "Player trends successfully loaded.",
                };
                dispatch("notification/add", notification, {root: true});
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error", message: "There was an error with player trends: " + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    async GetPlayerFullStats({commit, dispatch}, payload) {
        commit("SET_PLAYERDETAIL_LOADER", true);
        try {
            const res = await NflAllTeams.getFullStat(payload);
            commit("SET_FULL_STAT", res.data);
            commit("SET_PLAYERDETAIL_LOADER", false);
        } catch (err) {
            const notification_1 = {
                type: "error", message: "There was an error with fetching full stats: " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async GetPlayerScoring({commit, dispatch}, payload) {
        try {
            const response = await NflAllTeams.getPlayerScoring(payload);
            commit("SET_SCORING", response.data);
        } catch (err) {
            const notification_1 = {
                type: "error", message: "There was an error Scoring : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    updateSavedLineup({commit, dispatch}, payload) {
        NflAllTeams.updateLineup(payload)
            .then((response) => {
                const notification = {
                    type: "success", message: "Lineup update successfully In Nfl.",
                };
                dispatch("notification/add", notification, {root: true});
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error", message: "There was an error Scoring : " + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    async SetProjection({dispatch}, payload) {
        try {
            const res = await common.setProjection(payload);
            if (res.data.success) {
                const notification = {
                    type: "success", message: "Projection update successfully In Nfl.",
                };
                dispatch("notification/add", notification, {root: true});
            }
        } catch (err) {
            const notification_1 = {
                type: "error", message: "There was an error set Projection : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getNflProps({commit, dispatch}) {
        try {
            const res = await NflAllTeams.getNflProps();
            commit("SET_NFL_PROPS", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success", message: "Data fetched successfully In Nfl.",
                };
                dispatch("notification/add", notification, {root: true});
            }
        } catch (err) {
            const notification_1 = {
                type: "error", message: "There was an error with Nfl_props : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getADP({commit, dispatch}) {
        commit("SET_LOADING", true);

        try {
            const res = await NflAllTeams.getAvgDraftPos();
            commit("SET_ADP", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success", message: "ADP Loaded in Nfl.",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_LOADING", false);
        } catch (error) {
            const notification_1 = {
                type: "error", message: "There was an error while fetching ADP in NFL : " + error.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getNflNewsData({commit, dispatch}) {
        commit("SET_LOADING", true);
        try {
            const res = await NflAllTeams.getNflNews();
            commit("SET_NFL_NEWS", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success", message: "News fetched successfully In NFL.",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_LOADING", false);
        } catch (err) {
            const notification_1 = {
                type: "error", message: "There was an error with NFL daily news : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getTeamDepth({commit, dispatch}) {
        commit("SET_LOADING", true);
        try {
            const response = await NflAllTeams.getNflTeamDepthChart();
            commit("SET_TEAM_DEPTH", response.data);
            if (response.data.success) {
                const notification = {
                    type: "success", message: "Depth chart fetched successfully In NFL.",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_LOADING", false);
        } catch (error) {
            const notification_1 = {
                type: "error", message: "There was an error with NFL depth chart : " + error.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async saveRankings({commit, dispatch}, payload) {
        commit("SET_RANKING_LOADING", true);
        try {
            const response = await NflAllTeams.saveNflRanking(payload);
            if (response.data.success) {
                const notification = {
                    type: "success", message: "Player Rankings set Successfully",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_RANKING_LOADING", false);
        } catch (error) {
            const notification_1 = {
                type: "error", message: "There was an error set Ranking : " + error.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async saveSeasonRankings({commit, dispatch}, payload) {
        commit("SET_RANKING_LOADING", true);
        try {
            const response = await NflAllTeams.saveNflSeasonRanking(payload);
            if (response.data.success) {
                const notification = {
                    type: "success", message: "Season Rankings set Successfully",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_RANKING_LOADING", false);
        } catch (error) {
            const notification_1 = {
                type: "error", message: "There was an error set Season Ranking : " + error.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getRankings({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        try {
            const res = await NflAllTeams.getNflRanking(payload);
            commit("SET_RANKINGS", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success", message: "Player Rankings get Successfully",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_LOADING", false);
        } catch (error) {
            const notification_1 = {
                type: "error", message: "There was an error fetching Ranking : " + error.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getSeasonRankings({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        try {
            const res = await NflAllTeams.getNflSeasonRanking(payload);
            commit("SET_RANKINGS", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success", message: "Season Rankings get Successfully",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_LOADING", false);
        } catch (error) {
            const notification_1 = {
                type: "error", message: "There was an error fetching Season Ranking : " + error.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },
};

const getters = {
    getTeamLoader(state) {
        return state.getTeamStatus;
    }, loadingStatus(state) {
        return state.loadingStatus;
    }, buildTeamLoader(state) {
        //console.log('Nfl loader start');
        return state.teamBuildStatus;
    }, topPlayersLoader(state) {
        return state.topPlaysStatus;
    }, getSlateID(state) {
        let slateId = state.AllSlate.map((item) => item.SlateID);
        return slateId;
    },

    getStuds(state) {
        let studs = state.playersDetail.filter((value) => parseInt(value.DraftKingsSalary) > 8000);
        return studs;
    },

    getStudForDkClsc(state) {
        let studs = [];

        studs.push(state.TopStudAndValues.DST_Players, state.TopStudAndValues.FLEX_Players, state.TopStudAndValues.QB_Players, state.TopStudAndValues.RB_Players, state.TopStudAndValues.TE_Players, state.TopStudAndValues.WR_Players);

        let newStuds = studs.map((playerPosition) => {
            // //console.log('playerPosition', _.slice(playerPosition, 0, 3));
            let slicedArray = _.slice(playerPosition, 0, 3);
            return slicedArray;
        });

        let finalStuds = [];
        finalStuds.push(...newStuds[0], ...newStuds[1], ...newStuds[2], ...newStuds[3], ...newStuds[4], ...newStuds[5]);
        finalStuds = _.uniqBy(finalStuds, "Name");
        return finalStuds;
    },

    getStudForDkSngl(state) {
        let studs = [];

        studs.push(state.TopStudAndValues.CPT_Players, state.TopStudAndValues.UTIL_Players);

        let newStuds = studs.map((playerPosition) => {
            let slicedArray = _.slice(playerPosition, 0, 3);
            return slicedArray;
        });

        let finalStuds = [];
        finalStuds.push(...newStuds[0], ...newStuds[1]);
        finalStuds = _.uniqBy(finalStuds, "Name");
        return finalStuds;
    },

    getStudForFdClsc(state) {
        let studs = [];

        studs.push(state.TopStudAndValues.DEF_Players, state.TopStudAndValues.FLEX_Players, state.TopStudAndValues.QB_Players, state.TopStudAndValues.RB_Players, state.TopStudAndValues.TE_Players, state.TopStudAndValues.WR_Players);

        let newStuds = studs.map((playerPosition) => {
            let slicedArray = _.slice(playerPosition, 0, 3);
            return slicedArray;
        });

        let finalStuds = [];
        finalStuds.push(...newStuds[0], ...newStuds[1], ...newStuds[2], ...newStuds[3], ...newStuds[4], ...newStuds[5]);
        finalStuds = _.uniqBy(finalStuds, "Name");
        return finalStuds;
    },

    getStudForFdSngl(state) {
        let studs = [];

        studs.push(state.TopStudAndValues.MVP_Players);

        let newStuds = studs.map((playerPosition) => {
            let slicedArray = _.slice(playerPosition, 0, 3);
            return slicedArray;
        });

        let finalStuds = [];
        finalStuds.push(...newStuds[0]);
        finalStuds = _.uniqBy(finalStuds, "Name");
        return finalStuds;
    },

    NewgetStuds(state, getters) {
        //  ;
        let operator = localStorage.getItem("gameOperator");
        let gameType = localStorage.getItem("gameType");
        if (state.TopStudAndValues) {
            if (operator == "DraftKings" && gameType == "Classic") {
                //console.log('$', operator, gameType);
                return getters.getStudForDkClsc;
            } else if (operator == "DraftKings" && gameType == "Single") {
                //console.log('$', operator, gameType);
                return getters.getStudForDkSngl;
            } else if (operator == "FanDuel" && gameType == "Classic") {
                //console.log('$', operator, gameType);
                return getters.getStudForFdClsc;
            } else if (operator == "FanDuel" && gameType == "Single") {
                //console.log('$', operator, gameType);
                return getters.getStudForFdSngl;
            }
        } else return;
    },

    getValue(state) {
        let values = state.playersDetail.filter((player) => !player.DraftKingsPosition.includes("DST") && parseInt(player.FPPDdraftking) < 550 && parseInt(player.FPPDfanduel) < 550);
        return values;
    },

    // ? filter by position...
    getFilterBySingle: (state) => (val) => {
        let filterPlayer = [];
        if (val == "CPT") {
            val = "CPT";
            state.position = "1";
        } else if (val == "FLEX") {
            val = "FLEX";
            state.position = "2";
        } else if (val == "Lck/Exl") {
            filterPlayer = state.playersDetail.filter((_players) => _players.type.includes("lock") || _players.type.includes("exclude"));
            return filterPlayer;
        }

        filterPlayer = state.playersDetail.filter((item) => {
            // console.log('item', item.OperatorRosterSlots);
            return item.OperatorRosterSlots == val;
        });
        // console.log({ filterPlayer });
        return filterPlayer;
    },

    getFilterByPositionInFanduel: (state) => (val) => {
        let filterPlayers = [];
        if (val == "MVP" || val == "FLEX") {
            state.position = val == "MVP" ? "1" : "2";
            // slot-priced slates send one row per roster slot, each with its own
            // salary. FanDuel spells the field OperatorRoasterSlots, DraftKings
            // spells it OperatorRosterSlots; unslotted slates send neither.
            filterPlayers = state.playersDetail.filter((item) => (item.OperatorRoasterSlots || item.OperatorRosterSlots) == val);
            return filterPlayers.length ? filterPlayers : state.playersDetail;
        } else if (val == "Lck/Exl") {
            // debugger;
            filterPlayers = state.playersDetail.filter((_players) => _players.type.includes("lock") || _players.type.includes("exclude"));
            return filterPlayers;
        }
        filterPlayers = state.playersDetail.filter((item) => {
            return item.FanDuelPosition == val;
        });
        //console.log(filterPlayers);
        return filterPlayers;
    },

    getFilterByPosition: (state) => (val) => {
        let filterPlayer = [];
        if (val.includes("QB")) {
            val = "QB";
        } else if (val.includes("RB")) {
            val = "RB";
        } else if (val.includes("WR")) {
            val = "WR";
        } else if (val.includes("TE")) {
            val = "TE";
        } else if (val === "DEF") {
            val = "D";
        } else if (val === "FLEX") {
            filterPlayer = state.playersDetail.filter((player) => !player.DraftKingsPosition.includes("QB") && !player.DraftKingsPosition.includes("DST"));
            return filterPlayer;
        } else if (val == "Lck/Exl") {
            filterPlayer = state.playersDetail.filter((_players) => _players.type.includes("lock") || _players.type.includes("exclude"));
            return filterPlayer;
        }

        filterPlayer = state.playersDetail.filter((player) => {
            if (state.operator == "DraftKings" && player.DraftKingsPosition !== null) {
                return player.DraftKingsPosition.includes(val);
            } else if (state.operator == "FanDuel" && player.FanDuelPosition !== null) {
                return player.FanDuelPosition.includes(val);
            }
        });
        return filterPlayer;
    },

    getFilterADP: (state) => (val) => {
        let filterPlayers = [];
        if (val.includes("QB")) {
            val = "QB";
        } else if (val.includes("RB")) {
            val = "RB";
        } else if (val.includes("WR")) {
            val = "WR";
        } else if (val.includes("TE")) {
            val = "TE";
        } else if (val.includes("K")) {
            val = "K";
        } else if (val.includes("DB")) {
            val = "DB";
        } else if (val.includes("CB")) {
            val = "CB";
        } else if (val.includes("DE")) {
            val = "DE";
        } else if (val.includes("S")) {
            val = "S";
        } else if (val.includes("DL")) {
            val = "DL";
        } else if (val.includes("LB")) {
            val = "LB";
        } else if (val.includes("DT")) {
            val = "DT";
        } else {
            filterPlayers = state.nfl_adp?.players;
            return filterPlayers;
        }

        filterPlayers = state.nfl_adp?.players.filter((_player) => {
            return _player.Position?.includes(val);
        });
        console.log(filterPlayers, "players");
        return filterPlayers;
    },
};
export default {
    namespaced: true, state, getters, actions, mutations,
};
